<template>
    <el-button v-bind="$attrs" v-on="$listeners" v-if="isShow">
        <slot></slot>
    </el-button>
</template>
<script>
    export default {
        props: ["id"],
        computed: {
            // 根据权限控制按钮的显示隐藏
            isShow() {
                return this.$store.getters.buttonsAuth.indexOf(this.id) != -1
                    ? true
                    : false;
            }
        }
    };
</script>